import * as React from 'react'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import MuiAlert, { type AlertProps } from '@mui/material/Alert'
import styled from '@mui/material/styles/styled'
// TODO: alert manually styled, severity='error' not working

const Alert = styled(MuiAlert, {
  name: 'AlertError',
  slot: 'Root',
  skipVariantsResolver: true,
})`
  color: #541313;
  background-color: #fbeaea;
`

type AlertErrorProps = Omit<AlertProps, 'icon' | 'severity'>

export function AlertError(props: AlertErrorProps) {
  return (
    <Alert
      icon={
        <InfoOutlined color="error" data-test-id="schedulingAlertErrorIcon" />
      }
      {...props}
    />
  )
}
